<template>
    <section class="hiw-wrapper">
        <v-col cols="12">
            <div class="justify-center hiw-title-text">
                How does it work?
            </div>
        </v-col>
        <v-layout row align-center justify-center class="hiw-info-container">
            <v-flex xs12 sm12 md12 lg6 xl6>
                <div class="img-wrapper">
                    <img
                        v-if="isEdgeBrowser"
                        class="hiw-image image-left"
                        src="@/assets/home/how-it-works-1.png"
                        alt="how it works"
                    />
                    <v-img
                        v-else
                        class="hiw-image image-left"
                        src="@/assets/home/how-it-works-1.png"
                        contain
                    ></v-img>
                </div>
            </v-flex>
            <v-flex xs12 sm12 md12 lg6 xl6>
                <div class="hiw-info-section flex-column d-flex">
                    <div class="hiw-info-group">
                        <p class="hiw-info-title font-weight-bold">
                            Go to the store and buy Nexon Game Card…
                        </p>
                        <p class="hiw-info-subtitle">
                            Find a store near you that carries Nexon Game Card.
                            You can buy them online or at several retail stores
                            in your community using local payment methods.
                        </p>
                        <div class="hiw-btn-wrapper">
                            <v-btn
                                class="hiw-btn"
                                height="54"
                                width="180"
                                depressed
                                rounded
                                :ripple="false"
                                to="/retailers"
                                data-ga="Home Interaction|View Retailers"
                                >View Retailers</v-btn
                            >
                        </div>
                    </div>
                </div>
            </v-flex>
        </v-layout>

        <v-layout
            row
            align-center
            justify-center
            class="flex-row-reverse hiw-info-container"
        >
            <v-flex xs12 sm12 md12 lg6 xl6>
                <div class="img-wrapper">
                    <img
                        v-if="isEdgeBrowser"
                        class="hiw-image image-right"
                        src="@/assets/home/how-it-works-2.png"
                        alt="how it works"
                    />
                    <v-img
                        v-else
                        class="hiw-image image-right"
                        src="@/assets/home/how-it-works-2.png"
                        contain
                    ></v-img>
                </div>
            </v-flex>
            <v-flex xs12 sm12 md12 lg6 xl6>
                <div class="hiw-info-section flex-column d-flex ">
                    <div class="hiw-info-group">
                        <p class="hiw-info-title font-weight-bold">
                            Use Nexon Game Card to buy stuff…
                        </p>
                        <p class="hiw-info-subtitle">
                            Play games, shop for items, select Nexon Game Card
                            as the payment method and enter the PIN to make your
                            purchase. To find out which games accept Nexon Game
                            Card, click <Strong>View Games</Strong> below.
                        </p>
                        <div class="hiw-btn-wrapper">
                            <v-btn
                                class="hiw-btn"
                                height="54"
                                width="180"
                                depressed
                                rounded
                                :ripple="false"
                                to="/partners"
                                data-ga="Home Interaction|View Games"
                                >View Games</v-btn
                            >
                        </div>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </section>
</template>

<script>
export default {
    name: 'how-it-works',
    data() {
        return {
            isEdgeBrowser: window.navigator.userAgent.indexOf('Edge') > -1,
        };
    },
};
</script>

<style lang="scss" scoped>
.hiw-wrapper {
    position: relative;
    min-height: 1200px;
    .hiw-title-text {
        font-weight: 900;
        font-family: KlavikaNX-Medium, serif;
        font-size: 40px;
        margin-bottom: 80px;
        line-height: 60px;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
    }
    .hiw-info-container {
        position: relative;
        margin: 0 0 90px 0;
        .img-wrapper {
            position: relative;
            .hiw-image {
                margin: 0 auto;
                width: 301px;
                height: 196px;
                margin-bottom: 30px;

                // EDGE ONLY HACK
                @supports (-ms-ime-align: auto) {
                    display: -webkit-box !important;
                }

                &:before {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    box-shadow: -50px 50px 50px -30px #ffffff inset,
                        50px 50px 50px -30px #ffffff inset;
                }
            }
        }
        .hiw-info-section {
            align-items: center;
            justify-content: center;
            .hiw-info-group {
                .hiw-info-title {
                    max-width: 378px;
                    font-size: 32px;
                    font-weight: 900;
                    font-family: KlavikaNX-Medium, serif;
                    line-height: normal;
                    text-align: center;
                    margin: 0 auto;
                    margin-bottom: 20px;
                }
                .hiw-info-subtitle {
                    max-width: 480px;
                    font-size: 16px;
                    line-height: 1.5;
                    text-align: center;
                    color: #000000;
                    margin: 0 auto;
                    margin-bottom: 20px;
                    font-weight: 500;
                }
                .hiw-btn-wrapper {
                    text-align: center;
                    .hiw-btn {
                        width: 180px;
                        height: 54px;
                        font-size: 14px;
                        letter-spacing: 0;
                        color: #ffffff;
                        background-color: #2960e8 !important;
                        &:hover {
                            box-shadow: 0 8px 15px 0 #5776cf !important;
                        }
                        &:focus {
                            background-color: #5776cf !important;
                            box-shadow: none !important;
                        }
                    }
                }
            }
        }
    }
}
@include break('sm') {
    .hiw-wrapper .hiw-info-container {
        .img-wrapper .hiw-image {
            width: 574px;
            height: 375px;
        }
    }
}

@include break('md') {
    .hiw-wrapper {
        .hiw-title-text {
            font-size: 46px;
            margin-bottom: 100px;
        }
        .hiw-info-container {
            margin-bottom: 66px;
            .img-wrapper {
                .hiw-image {
                    margin-bottom: 40px;
                }
            }
            .hiw-info-section {
                .hiw-info-group {
                    .hiw-info-title {
                        max-width: 410px;
                        font-size: 36px;
                        margin-bottom: 20px;
                    }
                }
            }
        }
    }
}
@include break('lg') {
    .hiw-wrapper {
        .hiw-title-text {
            font-size: 50px;
            margin-bottom: 118px;
        }
        .hiw-info-container {
            .img-wrapper {
                width: 100%;
                height: 100%;
                .hiw-image {
                    max-height: 469px;
                    max-width: 642px;
                    height: 100%;
                    width: 100%;
                    margin-bottom: 0;
                }
            }
            .hiw-info-section {
                .hiw-info-group {
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    .hiw-info-title {
                        max-width: 390px;
                        font-size: 38px;
                        margin-bottom: 30px;
                        text-align: left;
                    }
                    .hiw-info-subtitle {
                        max-width: 390px;
                        text-align: left;
                        margin-bottom: 30px;
                    }
                }
            }
        }
    }
}
@include break('xl') {
    .hiw-wrapper {
        max-width: 1920px;
        margin: 0 auto;
        .hiw-title-text {
            font-size: 60px;
            margin-top: 170px;
            margin-bottom: 130px;
        }
        .hiw-info-container {
            margin-bottom: 230px;
            .img-wrapper {
                .hiw-image {
                    max-height: 551px;
                    max-width: 789px;
                }
            }
            .hiw-info-section .hiw-info-group {
                .hiw-info-title {
                    max-width: 451px;
                    font-size: 48px;
                }
                .hiw-info-subtitle {
                    max-width: 451px;
                    font-size: 20px;
                }
            }
        }
    }
}
</style>
